/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>案例管理</el-breadcrumb-item>
      <el-breadcrumb-item>安装案例</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formProInfo" class="user-search">
			
          <el-form-item label="案例名称" >
            <el-input size="small" v-model="formProInfo.name" placeholder="输入案例名称"></el-input>
          </el-form-item>
		  
    	  <el-form-item label="创建方式">
    	    <el-input size="small" v-model="formProInfo.createType" placeholder="输入案例创建方式"></el-input>
    	  </el-form-item>
		  
		  <el-form-item label="创建人">
		    <el-input size="small" v-model="formProInfo.createName" placeholder="输入创建人"></el-input>
		  </el-form-item>
		 
		  
         <!-- <el-form-item label="创建时间">
    	    <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
    	  </el-form-item>
          <el-form-item> -->
			<el-button size="small" type="info" icon="el-icon-refresh-left" @click="refrea" class="refrea">重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search" class="search">搜索</el-button>
           
          </el-form-item>
        </el-form>
		<div class="block">
		 <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;" @change="choosebt">
			 <el-radio-button label="待审核" >待审核</el-radio-button>
			 <el-radio-button label="已通过">已通过</el-radio-button>
			 <el-radio-button label="已拒绝">已拒绝</el-radio-button>
		 </el-radio-group>     
		</div>
		 <el-button size="small" type="primary" icon="el-icon-plus" @click="add" class="add">新增</el-button>
        <!--列表-->
        <el-table size="small" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" prop="name" label="案例名称" >
          </el-table-column>
          <el-table-column align="center" prop="firstLevelName" label="创建人">
          </el-table-column>
		  <el-table-column align="center" prop="createType" label="创建方式">
		  </el-table-column>
		  <el-table-column align="center" prop="createTime" label="创建时间" >
		  </el-table-column>
         <!-- <el-table-column align="center" sortable prop="editTime" label="修改时间" min-width="120">
            <template slot-scope="scope">
              <div>{{scope.row.editTime|timestampToTime}}</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column align="center" sortable prop="status" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status=='1'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
              </el-switch>
            </template>
          </el-table-column> -->
          <el-table-column  align="center"  label="操作" min-width="140">
            <template slot-scope="scope">

              <el-button size="mini" type="success" @click="handlex(scope.row)">详情</el-button>
              <el-button size="mini"  type="primary" @click="handleEdit(scope.row)">编辑</el-button>
			  <!-- <el-button size="mini" type="danger" @click="deleteProInfo(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        

         


      </div>
    </template>

    <script>
    // 导入请求方法
    import { uploadFile } from '../../api/axiosFun';
    import {
      searchcase
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
		 
          loading: false, //是显示加载
         
          // 选择数据
          selectdata: [],
          tabPosition:'待审核',

          // 请求数据参数
          formProInfo: {
            pageIndex: 1,
            pageSize: 10,
            // 产品名称(支持右模糊查询)
            name: '',
            createType: '',
            createName:'',
			reviewStatue:'待审核',
           caseType:'安装案例'
			
          },
    	  
          //产品介绍列表
          proInfoList: [],
         
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          },
          
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getData(this.formProInfo)

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  //添加
		  add: function() {
		  	this.$router.push({ path: '/installationadd?shuo=' + '新增' })
		   
		  },
		  //编辑
		  handleEdit: function(row) {
		  	console.log(99999,row)
		  	this.$router.push({ path: '/installationadd?id='+row.id + '&shuo=' + '编辑' })
		   
		  },
		  //详情
		  handlex: function(row) {
		  	console.log(99999,row)
		  	this.$router.push({ path: '/installationbian?id='+row.id })
		   
		  },
		  choosebt(e){
			this.formProInfo.reviewStatue=this.tabPosition
				
			this.getData(this.formProInfo)
		  },
        // 获取数据方法
        getData(pageparm) {
          this.loading = true
         
          searchcase(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data

              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formProInfo.pageIndex = parm.currentPage
          this.formProInfo.pageSize = parm.pageSize
          this.getData(this.formProInfo)
        },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },
		
		refrea(){
			this.formProInfo.name=''
			this.formProInfo.createType=''
			this.formProInfo.createName=''
		},

        

      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 220px;
  }
  .el-input{
  	  width: 150px;
  }
  /deep/ .el-input--small{
  	  width: 150px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 70px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  /* .search{
	  position: absolute;
	  right: 0;
	  top: 68px;
  } */
  .add{
	  margin-bottom: 30px;
  }
  /* .refrea{
	  position: absolute;
	  right: 0;
	  top: 5px;
  }
  .user-search{
	  position: relative;
  } */
	.block{
		  display: flex;
	}
	/deep/ .block .el-input__inner{
		  line-height: 32px;
		  height: 32px;
		  border: 0;
	}
	/deep/ .el-input__icon{
		  font-size: 20px;
		  height: 36px;
		  line-height: 32px;
	}
	/deep/ .el-radio-button:first-child .el-radio-button__inner{
		 border: 0; 
	}
	/deep/ .el-radio-button__inner{
		  border: 0; 
	}
	/deep/ .el-radio-button__inner{
		  width: 90px;
	}
	/deep/ .el-radio-button__inner{
		  padding: 10px 20px;
	}
    </style>





// WEBPACK FOOTER //
// src/views/management/installation.vue